import { Flex } from "@chakra-ui/react";
import React from "react";
import RequestDemoForm from "../components/Form";
import RequestDemoSideContent from "../components/SideContent";
import { useDeviceWidth } from "../hooks/useDeviceWidth";


const RequestDemo = () => {
  const { isDesktopView } = useDeviceWidth();

  return (
    <>
      <Flex w="full" justifyContent="center">
        {isDesktopView && <RequestDemoSideContent />}
        <RequestDemoForm />
      </Flex>
    </>
  );
};

export default RequestDemo;
